import { render, staticRenderFns } from "./OzIndeterminateSpinner.vue?vue&type=template&id=8f7f0c1c&"
import script from "./OzIndeterminateSpinner.vue?vue&type=script&lang=ts&"
export * from "./OzIndeterminateSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports